import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const RequestTagsGroup = ({ title, children }) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="px-4 py-2">
      <div className="flex flex-row items-center justify-between">
        <h3 className="text-slate-900 text-sm font-semibold">{title}</h3>
        <button
          type="button"
          className="px-6 py-2 text-slate-500 font-semibold"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? (
            <ChevronUpIcon className="h-4 w-4 " />
          ) : (
            <ChevronDownIcon className="h-4 w-4" />
          )}
        </button>
      </div>
      <div className={!expanded ? 'hidden' : ''}>{children}</div>
    </div>
  );
};

RequestTagsGroup.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default RequestTagsGroup;
